import { api, getAllPages } from "./client";
import type {
  ApiKey,
  ApiKeyCreateRequest,
  ApiKeyCreateResponse,
  ApiKeyUpdateRequest,
} from "@/types/api-key";

interface ResponseID {
  id: string;
}

export const getApiKeys = (params?: { deactivated?: boolean }) =>
  getAllPages<ApiKey>("/dashboard/api-keys", {
    serviceId: null,
    params,
  });

export const createApiKey = (data: ApiKeyCreateRequest) =>
  api.post<ApiKeyCreateResponse>("/dashboard/api-keys", data, {
    serviceId: null,
  });

export const updateApiKey = (id: string, data: ApiKeyUpdateRequest) =>
  api.patch<ResponseID>(`/dashboard/api-keys/${id}`, data, {
    serviceId: null,
  });

export const deleteApiKey = (id: string) =>
  api.delete<ResponseID>(`/dashboard/api-keys/${id}`, { serviceId: null });
